<template>
    <div>
        <div v-if="title || $slots.title" class="mb-1 text-sm font-medium text-gray-700">
            <slot name="title">{{ title }}</slot>
        </div>
        <div class="text-gray-500 text-sm font-normal h-[38px] flex items-center">
            <slot>{{ value }}</slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
    }
}
</script>

<style>

</style>
